 
 

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import api from 'services/api';
import Modal from 'v3/components/Modal';
import Radio from 'v3/components/Radio';
import Select from 'v3/components/Select';
import Text from 'v3/components/Text';
import Button from 'v3/components/Button';
import { useSnackbar } from 'v3/components/Snackbar';
import { useVehicle } from '../../context';

function Drivers({ isOpen, onClose }) {
  const vehicle = useVehicle();
  const params = useParams();
  const snackbar = useSnackbar();

  const [driver, setDriver] = useState();
  const [mainDriver, setMainDriver] = useState(vehicle.data.drivers.length === 0);

  const hasCurrentDriver = vehicle.data.drivers.some((item) => item.current);

  const [errors, setErrors] = useState('');

  async function fetchDrivers(search) {
    try {
      const response = await api.get('drivers/select', { params: { search } });
      return response.data;
    } catch (ex) {
      return [];
    }
  }

  async function handleAddDriver(event) {
    event.preventDefault();

    const getIdentifier = (item) => item?.id || item?.value;

    if (
      !vehicle.data.currentDriverEditing &&
      vehicle.data.drivers.map(getIdentifier).includes(getIdentifier(driver))
    ) {
      setErrors('Esse motorista já foi selecionado');
      return;
    }

    const currentDrivers = vehicle.data?.drivers || [];

    try {
      let updatedDrivers = (vehicle.data?.drivers || []).filter(
        (drivers) => getIdentifier(drivers) !== getIdentifier(driver),
      );
      const currentDriver = currentDrivers.find((item) => item.current);

      if (mainDriver)
        updatedDrivers = updatedDrivers.map((item) => {
          if (getIdentifier(item) === getIdentifier(currentDriver)) {
            return { ...item, current: false };
          }

          return item;
        });

      if (params.id) {
        if (currentDriver && mainDriver) {
          await api.put(`v3/vehicle/driver/${params.id}`, {
            driver_id: getIdentifier(currentDriver),
            current: false,
            wagons_id: vehicle.data.implements.map((wagon) => wagon.id),
          });
        }

        await api.put(`v3/vehicle/driver/${params.id}`, {
          driver_id: getIdentifier(driver),
          current: mainDriver,
          wagons_id: vehicle.data.implements.map((wagon) => wagon.id),
        });

        vehicle.setPrevVehicle((old) => ({
          ...old,
          drivers: [
            ...updatedDrivers,
            {
              ...driver,
              current: mainDriver,
            },
          ],
        }));
      }

      vehicle.setData({
        drivers: [
          ...updatedDrivers,
          {
            ...driver,
            current: mainDriver,
          },
        ],
      });
    } catch (error) {
      snackbar.show(<Text>Não foi possível editar os motoristas.</Text>, {
        type: 'error',
      });
    } finally {
      onClose(true);
      setDriver('');
      setErrors();
      vehicle.setData({
        currentDriverEditing: null,
      });
      setMainDriver(false);
    }
  }

  useEffect(() => {
    if (hasCurrentDriver) {
      setMainDriver(false);
    }
    if (vehicle.data.drivers.length === 0) setMainDriver(true);
  }, [vehicle.data.drivers]);

  useEffect(() => {
    if (vehicle.data.currentDriverEditing) {
      setDriver(vehicle.data.currentDriverEditing);
      setMainDriver(vehicle.data.currentDriverEditing.current);
    }

    if (!vehicle.data.currentDriverEditing) {
      setDriver(null);
    }
  }, [vehicle.data.currentDriverEditing]);

  return (
    <>
      <Modal
        show={isOpen}
        onHide={onClose}
        heading={
          <Text color="dark" type="header">
            Motorista
          </Text>
        }
        body={
          <form onSubmit={handleAddDriver}>
            <Row>
              <Col xs={12}>
                <Select.Async
                  label="Nome"
                  onSearch={fetchDrivers}
                  value={driver}
                  onChange={(value) => {
                    if (value) {
                      setDriver({ ...value, value: value.id });
                    } else {
                      setDriver(value);
                    }
                  }}
                  getOptionLabel={(option) => option.social_name}
                  getOptionValue={(option) => option.id}
                  error={errors || vehicle.errors.drivers}
                  isDisabled={!!vehicle.data.currentDriverEditing}
                />
              </Col>
              {vehicle.data.drivers.length === 0 ? null : (
                <Col xs={12} className="mt-3">
                  <Radio.Group
                    label="Tornar esse motorista atual"
                    onChange={({ target }) => setMainDriver(target.value)}
                    value={mainDriver}
                    horizontal
                  >
                    <Radio value>
                      <Text color="dark" type="label">
                        Sim
                      </Text>
                    </Radio>
                    <Radio value={false}>
                      <Text color="dark" type="label">
                        Não
                      </Text>
                    </Radio>
                  </Radio.Group>
                </Col>
              )}
              <Col xs={12} className="align-items-center d-flex justify-content-center my-4">
                <Button type="submit" disabled={!driver}>
                  {vehicle.data.currentDriverEditing ? 'Editar' : 'Adicionar'}
                </Button>
              </Col>
            </Row>
          </form>
        }
      />
    </>
  );
}

export default Drivers;
